import React from "react";
import axios from "axios";
import Spinner from "../components/spinner";
import Profile from "../components/profile";
import NotFound from "./err";
class profile extends React.Component {
  constructor({ match }) {
    super();
    this.state = {
      login: match.params.login,
      isLoading: true,
      profile: {},
      repos: [],
      err: false
    };
  }

  componentDidMount() {
    axios
      .get(`https://api.github.com/users/${this.state.login}`)
      .then(response => {
        this.setState({ profile: response.data });
        axios
          .get(`https://api.github.com/users/${this.state.login}/repos`)
          .then(response => {
            this.setState({
              repos: response.data,
              isLoading: false,
              err: false
            });
          });
      })
      .catch(err => {
        this.setState({ err: true, isLoading: false });
      });
  }

  render() {
    return (
      <div>
        {this.state.err ? (
          <NotFound />
        ) : this.state.isLoading ? (
          <Spinner />
        ) : (
          <Profile profile={this.state.profile} repos={this.state.repos} />
        )}
      </div>
    );
  }
}

export default profile;
